import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { ROUTES } from "~/utils/routing/routeUtils";
import { queryTourTarget } from "../utils/queryTourTarget";

const getPropertyIdFromPath = (): string | null => {
  const segments = window.location.pathname.split("/").filter(Boolean);
  if (segments.length === 2 && segments[0] === "property") {
    return segments[1];
  }
  return null;
};

/**
 * Setup walkthrough: Property Details → Buildings tab → Add Building.
 */
export const propertyDetailsSetupTour = (t: TFunction): TourStep[] => {
  const propertyID = getPropertyIdFromPath();
  const addBuildingPath = propertyID
    ? `${ROUTES.addBuilding}?propertID=${propertyID}`
    : ROUTES.addBuilding;

  return [
    {
      title: t("Tour_Setup_PropertyDetails_Buildings_Title"),
      description: t("Tour_Setup_PropertyDetails_Buildings_Description"),
      target: () => queryTourTarget("property-buildings-tab-content"),
      placement: "top",
    },
    {
      title: t("Tour_Setup_PropertyDetails_AddBuilding_Title"),
      description: t("Tour_Setup_PropertyDetails_AddBuilding_Description"),
      target: () => queryTourTarget("property-add-building-button"),
      placement: "left",
      recommendedTours: [
        {
          label: t("Tour_Setup_Next_AddBuilding"),
          path: addBuildingPath,
        },
      ],
    },
  ];
};
